export const ELECTRON_CANDYBAR_LINK = '/electron-candybar';
export const ELECTRON_TEMPLATE_PICKER_LINK = '/electron-template-picker';
